<template>
    <div class="app">
        <TopNav></TopNav>
        <div class="center">
            <div class="me-hd">
                <div class="content_row">
                    <div class="me-hd-left">
                        <h1>杭州菜商云数字科技有限公司</h1>
                        <ul>
                            <li>共赢、合作、服务</li>
                            <li>以共赢的思维作为指导</li>
                            <li>以与合作伙伴坦诚、密切合作为手段，达成服务好客户的目标</li>
                            <li>实现合作伙伴、客户、员工多方共赢的局面</li>
                        </ul>
                    </div>
                    <div class="me-hb-right">
                        <p>杭州菜商云数字科技有限公司以服务市场运营方为公司宗旨，以市场运营需求为公司责任，以提升市场运营效率为公司目标。公司致力于通过数字化手段聚集外部资源为市场引流，以数字化手段聚集市场周边消费者，帮助市场运营方提升市场运营效益，以数字化手段协助食品安全管控的数字科技公司。
                            公司是阿里巴巴旗下客如云体系的系统方案供应商及产品代理商。 公司由市场智慧化、数字化行业资深人士组建，核心团队有丰富的各类市场智慧化改造实施成功经验。</p>
                    </div>
                </div>
            </div>
            <!-- 公司简介-->
            <div class="csy-lc">
                <div class="content_row">
                    <div class="title_content">
                        <div class="title">
                            <img src="../assets/tb.png" style="margin-right: .4rem;" alt="">
                            <h1>公司介绍</h1>
                            <img src="../assets/tb 1.png" style="margin-left: .4rem;" alt="">
                        </div>
                    </div>
                    <div class="csy-lc-box2">
                        <h2>杭州菜商云数字科技有限公司</h2>
                        <p>杭州菜商云数字科技有限公司以服务市场运营方为公司宗旨，以市场运营需求为公司责任，以提升市场运营效率为公司目标。公司致力于通过数字化手段聚集外部资源为市场引流，以数字化手段聚集市场周边消费者，帮助市场运营方提升市场运营效益，以数字化手段协助食品安全管控的数字科技公司。
                            公司是阿里巴巴旗下客如云体系的系统方案供应商及产品代理商。 公司由市场智慧化、数字化行业资深人士组建，核心团队有丰富的各类市场智慧化改造实施成功经验。</p>
                        <p>公司以移动互联网、物联网、云计算、大数据、移动支付、人工智能等新一代信息技术为手段，提供数字农贸、数字农批整体解决方案、IT基础设施服务及其他智慧生态服务。</p>
                    </div>
                </div>
            </div>
        </div>
        <BottomNav></BottomNav>
    </div>
</template>

<script>
import TopNav from '../components/TopNav.vue'
import BottomNav from '../components/BottomNav.vue'
export default {
    components: { TopNav, BottomNav },
    data() {
        return {

        }
    },
    created() { },
    mounted() { },
    methods: {},
}
</script>

<style lang="less" scoped>
.app {
    width: 100vw;
    height: 100vh;
    background-size: cover;
    z-index: -1;
    overflow-x: hidden;
}

.center {
    width: 100%;
    min-height: calc(100vh - .8333rem - 5.9063rem);
    margin-top: .8333rem;
}

.content_row {
    width: 100%;
    height: 100%;
    padding: 0 4.25rem;
    box-sizing: border-box;
}

.me-hd {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 5.2083rem;
    background: url(../assets/bj4.png) no-repeat center;
    background-size: 100% 5.2083rem;
    margin-top: .8333rem;
    z-index: -1;
}

.me-hd .content_row .me-hd-left {
    float: left;
    width: 6.0417rem;
    height: 5rem;

    margin-top: 0.1042rem;
}

.me-hd .content_row .me-hd-left h1 {
    width: 5.5rem;
    height: .7813rem;
    font-size: .4rem;
    letter-spacing: .0217rem;
    color: #fff;
    margin-top: 1.0417rem;
    padding-bottom: .3rem;
    border-bottom: 0.0208rem solid #fff;
    box-sizing: border-box;
}

.me-hd .content_row .me-hd-left ul {
    margin-top: .5729rem;
}

.me-hd .content_row .me-hd-left ul li {
    color: #fff;
    font-size: .3083rem;
}

.me-hb-right {
    float: right;
    width: 5rem;
    height: 5rem;
    margin-top: 0.1042rem;
}

.me-hb-right p {
    font-size: .2rem;
    letter-spacing: .0217rem;
    color: #fff;
    text-indent: 2em;
    line-height: .39rem;
    margin-top: 1.0417rem;
    box-sizing: border-box;
}

.me-hb-right p:nth-child(2) {
    margin-top: 0;
}

.csy-lc {
    display: flex;
    width: 100%;
    height: 7rem;
    margin-top: .5rem;
    /* background-color: pink; */
    text-align: center;
    box-sizing: border-box;
}

.csy-lc-box2 {
    width: 100%;
    height: 4.1667rem;
    margin-top: 0.6rem;
}

.csy-lc-box2 h2 {
    font-size: .3125rem;
}

.csy-lc-box2 p {
    margin-top: .5rem;
    letter-spacing: .0313rem;
    text-indent: 2em;
    font-size: .25rem;
    text-align: left;
    line-height: .4688rem;
}

.csy-lc-box2 p:nth-child(3) {
    margin-top: 0;
}

.title_content {
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    align-items: center;
}

.title_content .title {
    display: flex;
    align-items: center;
}

.title_content img {
    width: 1.1458rem;
    height: .2292rem;
}

.title_content h1 {
    font-size: .3958rem;
}

.title_content p {
    height: .3021rem;
    font-size: .2188rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #232A24;
    line-height: .3021rem;
    margin-top: .2917rem;
}
</style>